// Le vocabulaire du vivier. Ces listes sont reprises telles quelles par les contraintes
// de la base, par la validation des routes et par la consigne donnée au modèle : elles
// n'ont donc le droit d'exister qu'ici.

export const TYPES_ENGAGEMENT = ['Consultant', 'CDI', 'MT'] as const;
export type TypeEngagement = (typeof TYPES_ENGAGEMENT)[number];

export const CATEGORIES_DOCUMENT = ['cv', 'entretien', 'reference', 'contrat', 'autre'] as const;

// Les postures, les niveaux et les axes IA vivent désormais dans `domaine/ia.ts` :
// l'IA a assez de vocabulaire propre pour mériter son module.

export const DIRECTIONS = [
  'Direction générale',
  'DRH',
  'DSI · IT · digital',
  'Direction financière',
  'Direction commerciale et service client',
  'Direction des opérations',
  'Supply chain',
  'Direction de la transformation',
] as const;
export type Direction = (typeof DIRECTIONS)[number];

